<div class="cards-editor-component-edit-popup" style="--bar-color: {barColor}; --text-color: {textColor};">
  <div class="cards-editor-component-edit-control-bar theme-dark">
    <Menu>
      <div style="font-size: {iconSize}px; padding-right: 5px;">{title}</div>
      <!--<MenuItem iconF7="xmark" iconOnly {iconSize} on:click={onClose} />-->
      <div style="flex-grow: 1"></div>
      <MenuItem iconF7="xmark" iconOnly {iconSize} on:click={onClose} />
    </Menu>
  </div>
  <div bind:this={jsonEditorDiv} class="cards-editor-component-edit-json-editor">
  </div>
</div>

<style>*, *::before, *::after {
  box-sizing: border-box;
}

.cards-editor-component-edit-popup {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.cards-editor-component-edit-control-bar {
  width: 100%;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: var(--bar-color);
  color: var(--text-color);
  padding: 5px 0px;
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  z-index: 999;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  --f7-menu-bg-color: black;
  --f7-menu-text-color: white;
  --f7-menu-font-size: 12px;
  --f7-menu-item-height: 32px;
}

.cards-editor-component-edit-control-bar :global(.menu) {
  width: 100%;
}

.cards-editor-component-edit-json-editor {
  width: 100%;
  padding: 10px;
  flex-grow: 1;
  overflow: scroll;
  color: black;
}</style>

<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Menu, MenuItem } from 'framework7-svelte';
import { onDestroy, onMount } from 'svelte';
import { JSONEditor } from '@json-editor/json-editor/dist/jsoneditor.js';
import _ from 'lodash';
import { CardsEditorFileUploadCallbacks } from './CardsEditorComponentInterfaces';
import { Jodit } from 'jodit';
import 'jodit/build/jodit.min.css';
export let closePopup;
export let title = '';
export let barColor = '#aaaaaa';
export let textColor = 'white';
export let schema = {};
export let data = {};
export let onUpdate = () => { };
export let onFileUpload = () => { };
const iconSize = 20;
let jsonEditorDiv;
let jsonEditor;
let lastSchema = {};
if (!window.Jodit) {
    window.Jodit = Jodit;
}
function onClose() {
    closePopup();
}
function onDataChanged() {
    console.log('ON DATA CHANGED', jsonEditor.getValue());
    onUpdate(jsonEditor.getValue());
}
function createJsonEditor() {
    lastSchema = schema;
    // I don't like doing this, but json-editor won't pass options to Jodit
    window.Jodit.defaultOptions.controls.image = {
        //name: "Upload Image",
        tooltip: "Upload image to website.",
        //iconURL: "https://www.kindpng.com/picc/m/261-2619141_cage-clipart-victorian-cloud-upload-icon-svg-hd.png",
        exec: ((editor) => __awaiter(this, void 0, void 0, function* () {
            const fileUpload = (file) => {
                return new Promise((resolve, reject) => {
                    onFileUpload(file, {
                        onFileUploadStarted(id) {
                            console.log('FILE UPLOAD STARTED!', id);
                        },
                        onFileUploadProgress(id, percent) {
                            console.log('FILE UPLOAD PROGRESS!', id, percent);
                        },
                        onFileUploadComplete(id, url) {
                            console.log('FILE UPLOAD COMPLETE!', id, url);
                            resolve(url);
                        },
                        onFileUploadError(id, reason) {
                            console.log('FILE UPLOAD ERROR :(', id, reason);
                            reject(reason);
                        }
                    });
                });
            };
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.click();
            input.onchange = function () {
                return __awaiter(this, void 0, void 0, function* () {
                    const imageFile = input.files[0];
                    if (!imageFile) {
                        return;
                    }
                    if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
                        return;
                    }
                    const url = yield fileUpload(imageFile);
                    const image = editor.selection.j.createInside.element('img');
                    image.setAttribute('src', url);
                    image.setAttribute('style', 'max-width: 100%');
                    editor.selection.insertNode(image);
                });
            };
        }))
    };
    //(<any>window).Jodit.defaultOptions.buttonsXS[1] = 'uploadImage';
    jsonEditor = new JSONEditor(jsonEditorDiv, {
        schema,
        startval: data,
        disable_collapse: true,
        disable_edit_json: true,
        disable_properties: true,
        remove_empty_properties: true,
        no_additional_properties: true,
        use_default_values: false,
        show_opt_in: true,
        display_required_only: false,
        object_layout: 'categories',
        theme: 'html',
        // NOTE: This doesn't work, but it should.
        /*
        jodit: {
          disabled: false,
          controls: {
            uploadImage: ...
          }
        },
        */
        upload: {
            auto_upload: true,
            enable_drag_drop: true,
            upload_handler: (type, file, cbs) => {
                if (type === 'root.upload_fail') {
                    cbs.failure('Upload failed.');
                    return;
                }
                onFileUpload(file, {
                    onFileUploadStarted(id) {
                        console.log('FILE UPLOAD STARTED!', id);
                    },
                    onFileUploadProgress(id, percent) {
                        console.log('FILE UPLOAD PROGRESS!', id, percent);
                        cbs.updateProgress(percent);
                    },
                    onFileUploadComplete(id, url) {
                        console.log('FILE UPLOAD COMPLETE!', id, url);
                        cbs.updateProgress();
                        cbs.success(url);
                    },
                    onFileUploadError(id, reason) {
                        console.log('FILE UPLOAD ERROR :(', id, reason);
                        cbs.failure(reason);
                    }
                });
            }
        }
    });
    jsonEditor.on('change', onDataChanged);
}
function destroyJsonEditor() {
    jsonEditor.off('change', onDataChanged);
    jsonEditor.destroy();
}
function updateSchema(newSchema) {
    //console.log('updateSchema', newSchema);
    if (!jsonEditor || _.isEqual(lastSchema, newSchema)) {
        return;
    }
    //console.log('updateSchema RECREATING JSON EDITOR', newSchema);
    destroyJsonEditor();
    createJsonEditor();
}
$: updateSchema(schema);
onMount(() => {
    createJsonEditor();
});
onDestroy(() => {
    if (jsonEditor) {
        destroyJsonEditor();
    }
});
</script>